export default "__VITE_ASSET__ed1bb6f7__"